import { BillingDiscountsArray } from './../../models/ss-api/responses/billing.discount.response';
import { Component, OnInit } from '@angular/core';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SortBot } from '../../../app/helpers/sort';
import { Angular2Csv } from 'angular2-csv';
import { Router } from '@angular/router';
import { LicenseManager } from '../../managers/License.manager';

@Component({
    selector: 'discount-report',
    templateUrl: './discount.report.component.html',
    styleUrls: ['./discount.report.component.css']
})
export class DiscountReportComponent implements OnInit {

    // VARIABLES
    IsBusy: boolean = false;

    Discounts: BillingDiscountsArray;
    CreditFilterInput: string;
    DiscountFilterInput: string;

    resultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 25;

    constructor(private api: ssApiService,
        private gb: GlobalService,
        private router: Router) { }

    ngOnInit() {
        this.gb.SetPageTitle('Discount Report');
        this.LoadDiscounts();
    }

    SortBy(sortVar1: string, sortVar2: string = '') {
        this.Discounts = SortBot.SortAuto(this.Discounts, sortVar1, sortVar2);
    }

    LoadDiscounts() {
        this.IsBusy = true;

        let disposable = this.api.GetBillingDiscounts().subscribe(response => {
            this.IsBusy = false;

            this.Discounts = response.Data;

            disposable.unsubscribe();
        });
    }

    ExportToCSV() {
        let options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: ['Member', 'Email', 'Company', 'LicenseKey', 'Month', 'Year', 'Amount', 'Description', 'Reason']
        };

        let ExportData = [];

        this.Discounts.forEach(function (item) {
            ExportData.push({
                Member: item.FirstName + ' ' + item.LastName,
                Email: item.Email,
                Company: item.Company,
                LicenseKey: item.LicenseKey,
                Month: item.Month,
                Year: item.Year,
                Amount: item.Amount,
                Description: item.InvoiceDescription,
                Reason: item.Reason
            });
        });

        new Angular2Csv(ExportData, 'DiscountReport', options);
    }

    OnMemberClick(id: number) {
        this.router.navigate(['/member-profile', id]);
    }

    OnLicenseClick(licenseKey: string) {
        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(licenseKey, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.LoadDiscounts();
        });
    }

    paginateDiscounts(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

    Title() {
        let title = 'Discounts';
        if (this.Discounts && this.Discounts.length > 0) {
            title += ' (' + this.Discounts.length + ')';
        }

        return title;
    }

}
